import { useEffect } from 'react';
import { Text, Stack } from '@mantine/core';

export function ZoomClosedPage(): JSX.Element {
  useEffect(() => {
    window.close();
  }, []);

  return (
    <Stack align="center" justify="center" h="100vh" bg="dark.9">
      <Text c="gray.4">Meeting ended. You can close this tab.</Text>
    </Stack>
  );
}
